import * as React from 'react';
// import Grid from '@mui/material/Grid';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DateDropdown from '../../components/dateDropdown';
import TranslationIds from '../../../commons/translationIds';

export default function renderCustomDate (p) {
    const {
        fieldErrors,
        translate,
        item,
        customValues,
        updateCustomValues,
        translateWithValues,
    } = p;

    function getLabel () {
        if (item.required) {
            return `${item.name}*`;
        }
        return item.name;
    }

    function getHelperText () {
        if (fieldErrors[item.name]) {
            return translateWithValues(TranslationIds.REGISTRATION_REQUIRED_FIELD, { label: item.name });
        }
        return ``;
    }

    return (
        <DateDropdown
                ecalClassName='ecal-reg-field-custom-field-please-select-a-date'
                error={fieldErrors[item.name]}
                helperText={getHelperText()}
                label={getLabel()}
                translate={translate}
                value={customValues[item.name]}
                onChange={(v) =>  {
                    updateCustomValues({
                        [item.name]: v,
                    });
                }}

                onClose={() => {
                    updateCustomValues({
                        [item.name]: customValues[item.name],
                    });
                }}
            />
    );
}
